import React, { useState, useEffect, useContext } from 'react'
import { Loader, Item } from 'semantic-ui-react'
import { client } from '../config/globals'
import { AppContext } from './../providers'
import axios from 'axios'
import { placeholder } from './../utils/constants'

const onFetchImage = (html, store) => {
  const endpoint = store.client.demoAPI || client.default.demoAPI
  if (!html) return new Promise((resolve) => resolve(''))
  return axios({
    method: 'post',
    url: `${endpoint}/image`,
    responseType: 'arraybuffer',
    data: {
      'file_type': 'png',
      size: '300',
      html
    },
  })
}

const getDataUrl = (img) => {
  let dataUri = ''
  try {
    dataUri = new Buffer(img, 'binary').toString('base64')
    dataUri = `data:image/png;base64,${dataUri}`
  } catch {
    dataUri = placeholder
  }
  return dataUri
}

const Thumbnail = ({ html }) => {
  const { beeAPI } = useContext(AppContext)
  const { store } = beeAPI
  const [isLoading, setLoading] = useState(true)
  const [image, setImage] = useState(null)

  useEffect(() => {
    setLoading(true)
    onFetchImage(html, store)
      .then((results) => {
        if (results) {
          const dataUri = getDataUrl(results.data)
          setImage(dataUri)
        } else {
          setImage(placeholder)
        }
        setLoading(false)
      })
  }, [html])


  return (
    <>
      {
        (isLoading)
          ? (<Loader style={{'width':'150px'}} active inline='centered' size="medium"></Loader>)
          : (<Item.Image src={`${image}`} size='small' />)
      }
    </>
  )
}
export default Thumbnail
